import { useLocation } from "react-router-dom";
import { useSiteSettings } from "../contexts/SiteSettingsContext";
import Footer from "./Footer";
import Navbar from "./Navbar";

const ConditionalLayout = ({ children }) => {
    const location = useLocation();
    const { isComingSoon, loading: settingsLoading } = useSiteSettings();

    // Define routes where Navbar and Footer should be shown
    const showNavbarFooterRoutes = [
        "/", // Home page
        "/product", // Legacy product route
        "/category", // Category pages
        "/categories", // Legacy category routes
        "/my-orders", // My Orders page
    ];

    // Check if current route should show Navbar and Footer
    const shouldShowLayout = showNavbarFooterRoutes.some(route => {
        if (route === "/") {
            return location.pathname === "/";
        }
        if (route === "/product") {
            return location.pathname.startsWith("/product");
        }
        if (route === "/category") {
            return location.pathname.startsWith("/category");
        }
        if (route === "/categories") {
            return location.pathname.startsWith("/categories");
        }
        if (route === "/my-orders") {
            return location.pathname === "/my-orders";
        }
        return location.pathname.startsWith(route);
    });

    // Hide navbar and footer if Coming Soon is active (except for admin routes)
    const shouldShowNavbarFooter = !settingsLoading && !isComingSoon && shouldShowLayout && !location.pathname.startsWith("/admin");

    return (
        <div className="min-h-screen flex flex-col">
            {shouldShowNavbarFooter && <Navbar />}
            <main className={shouldShowNavbarFooter ? "flex-grow" : "min-h-screen"}>{children}</main>
            {shouldShowNavbarFooter && <Footer />}
        </div>
    );
};

export default ConditionalLayout;
